import { IStyleProps, mergeStyles } from '@cian/components';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const style = require('./wrapper.css');

export interface IModalWrapperProps {
  containerStyle?: IStyleProps;
  onClose?(): void;
}

export class ModalWrapper extends React.Component<IModalWrapperProps> {
  public componentDidMount() {
    document.addEventListener('keyup', this.escHandler);
    document.body.style.overflow = 'hidden';
  }

  public componentWillUnmount() {
    document.removeEventListener('keyup', this.escHandler);
    document.body.style.overflow = 'auto';
  }

  public render() {
    const { containerStyle } = this.props;

    return ReactDOM.createPortal(
      <div {...mergeStyles(style['container'], containerStyle)}>
        <div className={style['wrapper']}>
          <div className={style['overlay']} onClick={() => this.props.onClose && this.props.onClose()} />
          {this.props.children}
        </div>
      </div>,
      document.body,
    );
  }

  private escHandler = (event: KeyboardEvent) => {
    if (event.keyCode === 27 && this.props.onClose) {
      this.props.onClose();
    }
  };
}
